import { dateFormator, mapTableRows } from "../../../../utils";
import {
  Backdrop,
  Button,
  FormFieldSet,
  TableAdv,
  useFormHandler,
} from "../../../../components";
import { upcommingpayfrequency } from "../../../../assets/data/projectData";
import { pastpaydaytableData } from "../../../../assets/data/candidatesData";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  clearEmpPayConfigMain,
  clearPayroll,
  getAllEmpPayConfigsStart,
  getAllPayrollStart,
} from "../../../../redux/slices/payroll/payrollSlice";
import { usePagination } from "../../../../hooks";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import dayjs from "dayjs";
import axiosRequest from "../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../redux/apiConfig";
import PayDayDetails from "./UpcomingPaydays/PayDayDetails";
import { exactUTCDate } from "../../../../utils/dateFormator";

const PastPaydays = () => {
  const dispatch = useDispatch();
  const [totalPastPaydays, setTotalPastPaydays] = useState(0);
  const [selectedPayDay, setSelectedPayDay] = useState(null);
  const [forceRender, setForceRender] = useState(false);

  // const { value } = useSelector((state) => state.totalCount);

  // const totalCount = value?.payrolls?.data;

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      // dispatch(
      //   getClientsStart({
      //     page: newPage,
      //     limit: newLimit,
      //     filter: {},
      //     sort: { uiid: -1 },
      //     // sort: { uiid: 1 },
      //     ret: "uiid businessName generalInfo email contact placements jobCode recordStatus",
      //     ref: "PlacementWithEmp",
      //     incl: "employeeId jobInfo.startDate jobInfo.endDate jobInfo.projectEndDate jobInfo.jobCode",
      //   })
      // );
    }
  );
  const { payroll: pastPaydaysData, loading } =
    useSelector((state) => state.payRoll) || {};
  useEffect(() => {
    dispatch(
      getAllPayrollStart({
        coll: "Payroll",
        limit: limit,
        page: page,
        useAggregate: true,
        // ref
        filters: {
          past: {
            type: "AG_GROUP",
            value: ["payCycle.from", "payCycle.to", "salaryProfileId"],
            // count:true
          },
        },
      })
    );
    // dispatch(
    //   totalCountStart({
    //     collection: "payrolls",
    //     coll: "Payroll",
    //     filters: {
    //       past: {
    //         type: "AG_GROUP",
    //         value: ["period.from", "period.to", "profile"],
    //       },
    //     },
    //   })
    // );
    const fetchTotalCount = async () => {
      const response = await axiosRequest({
        method: "GET",
        url: ENDPOINTS.PAYROLL.GET_ALL,
        params: {
          coll: "Payroll",
          useAggregate: true,
          // ref
          fil: JSON.stringify({
            past: {
              type: "AG_GROUP",
              value: ["payCycle.from", "payCycle.to", "salaryProfileId"],
              count: true,
            },
          }),
        },
      });
      const totalCount = response?.data?.data || [];
      // console.log("totalCount", totalCount);
      setTotalPastPaydays(totalCount?.[0]?.TotalCount || 0);
    };
    fetchTotalCount();
    return () => {
      dispatch(clearPayroll());
    };
  }, [dispatch, limit, page,forceRender]);

  const { formData, errors, handleChange, validateAllFields } = useFormHandler({
    selectPayFrequency: "",
    payProfile: "",
  });

  const handlePayDayClick = (row) => {
    setSelectedPayDay(row);
  };
  const forceRerender = () => {
    setForceRender((prev) => !prev);
  };

  const tableData = pastPaydaysData?.data || [];
  const columns = [
    {
      key: "payDay",
      label: "Pay Day",
      render: (row) => {
        return (
          <span
            className="cursor-pointer text-info"
            onClick={() => handlePayDayClick(row)}
          >
            {exactUTCDate(row.payDay)}
            {/* {dateFormator(actualPayDay, "month-day-year")} */}
          </span>
        );
      },
    },
    {
      key: "payPeriod",
      label: "Pay Period",
      render: (row) => {
        // const [fromStr, toStr] = row.payPeriod?.split(" TO ") || [];
        // if (!fromStr || !toStr) return "-";
        const fromdate = row?.payCycle?.from
          ? dayjs(row?.payCycle?.from).utc().format("MM/DD/YYYY")
          : "";
        const todate = row?.payCycle?.to
          ? dayjs(row?.payCycle?.to).utc().format("MM/DD/YYYY")
          : "";
        const formatDate = fromdate && todate ? `${fromdate} to ${todate}` : "";
        return `${formatDate || "-"}`;
      },
    },
    {
      key: "linkedEmployees",
      label: "Linked Employees",
      render: (row) => {
        return (
          <span className="cursor-pointer ">{row?.docs?.length || "-"}</span>
        );
      },
    },
    {
      key: "payProfile",
      label: "Pay Profile",
      render: (row) => {
        return (
          <span className="cursor-pointer ">
            {row?.salaryProfileId?.name || "-"}
          </span>
        );
      },
    },
    {
      key: "payFrequency",
      label: "Pay Frequency",
    },
    {
      key: "unpaidEmpoyees",
      label: "Unpaid Empoyees",
    },
    {
      key: "totalPayout",
      label: "Total Payout",
    },
    // {
    //   key: "lastUpdate",
    //   label: "Last Update",
    //   render: (row) => dateFormator(row.lastUpdate, "datetime"),
    // },
  ];
  const mappedRows = mapTableRows(tableData, columns);

  return (
    <div className="flex flex-1 overflow-hidden flex-col">
      {selectedPayDay ? (
        <PayDayDetails
          row={selectedPayDay}
          onClose={() => setSelectedPayDay(null)}
          forceRerender={forceRerender}
          paycyclevalue={selectedPayDay.period}
          paydayvalue={dateFormator(selectedPayDay.payDay, "month-day-year")}
          totalempvalue={selectedPayDay.linkedEmployees}
        />
      ) : (
        <TableAdv
          tableId="payroll_pastpaydays"
          rows={mappedRows}
          columns={columns}
          serverPagination={true}
          totalCount={totalPastPaydays}
          page={page}
          limit={limit}
          onPaginationChange={setPage}
          onLimitChange={handleLimitChange}
          toolbarRight={{
            add: [
              {
                component: (
                  <div className="flex gap-2 mt-2 mb-2 ">
                    <FormFieldSet
                      type="text"
                      title=""
                      size="sm" // this has no effect, bug?
                      placeholder="Pay Profile"
                      value={formData.payProfile || ""}
                      onChange={(value) => handleChange("payProfile", value)}
                      error={errors.payProfile}
                    />
                    <FormFieldSet
                      type="select"
                      size="sm"
                      title="Select Pay Frequency"
                      placeholder="Select Pay Frequency"
                      value={formData.selectPayFrequency || ""}
                      onChange={(value) =>
                        handleChange("selectPayFrequency", value)
                      }
                      error={errors.selectPayFrequency}
                      options={upcommingpayfrequency}
                    />
                    <div className="mt-5">
                      <Button size="sm" title={"Search"} onClick={""} />
                    </div>
                  </div>
                ),
              },
            ],
          }}
        />
      )}
    </div>
  );
};

export default PastPaydays;
